import { render } from "./CountrySelect.vue?vue&type=template&id=5009e3aa"
import script from "./CountrySelect.vue?vue&type=script&lang=ts"
export * from "./CountrySelect.vue?vue&type=script&lang=ts"
script.render = render

export default script